var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoanIconArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e68c6dde-c4a2-416b-a906-ba71d48c763b{fill:#0a1482;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f150ce31-8112-4299-8d96-87f1bf04fba4",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e68c6dde-c4a2-416b-a906-ba71d48c763b",
    d: "M186.58,96.08a10,10,0,0,0-14.16,0l-63,63V17.34a10,10,0,1,0-20,0V157.88L27.58,96.1a10,10,0,0,0-14.16,14.16l79.5,79.49a10,10,0,0,0,14.16,0l79.5-79.51A10,10,0,0,0,186.58,96.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanIconArrow);
export default __webpack_public_path__ + "static/media/LoanIcon_arrow.17b3a9b382ed992a2fabd0212cf8de16.svg";
export { ForwardRef as ReactComponent };